import { Group, Title, desktopFirstMediaQuery } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';
import type { ReactNode } from 'react';

import { MyCoursesTabs } from './MyCoursesTabs';

import { GameEntryComment } from '../../pages/games/entry/GameEntryComment';
import MyPageLayout from './index';

type MyCoursesLayoutProps = {
  children: ReactNode;
  pathname: string;
  description: string;
  title: string;
  isDetail?: boolean;
};

export function MyCoursesLayout({
  title,
  children,
  pathname,
  description,
  isDetail = false,
}: MyCoursesLayoutProps) {
  const { t } = useTranslation();

  return (
    <MyPageLayout
      meta={{
        title,
        description,
      }}
    >
      {!isDetail && (
        <>
          <Group gap={8}>
            <Title
              order={2}
              mb={8}
              styles={{
                root: {
                  [desktopFirstMediaQuery.mobile]: {
                    fontSize: 22,
                  },
                },
              }}
            >
              {t('내 학습')}
            </Title>
            <GameEntryComment />
          </Group>
          <MyCoursesTabs pathname={pathname} />
        </>
      )}
      {children}
    </MyPageLayout>
  );
}
